import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import ServiceAgreement from '@/views/ServiceAgreement.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/ufi'
  },
  {
    path: '/user-form',
    name: 'UserFormInput',
    component: () => import('../views/UserFormInput.vue')
  },
  {
    path: '/ufi',
    name: 'UserFormInput',
    component: () => import('../views/UserFormInput.vue'),
    meta: {
      title: '用户信息输入',
    }
  },
  {
    path: '/id-card-upload',
    name: 'IdCardUpload',
    component: () => import('../views/IdCardUpload.vue'),
    meta: {
      title: '身份证上传',
    }
  },
  {
    path: '/Payment',
    name: 'Payment',
    component: () => import('../views/Payment.vue'),
    meta: {
      title: '支付',
    }
  },
  {
    path: '/p',
    name: 'ProcessingPage',
    component: () => import('../views/ProcessingPage.vue'),
    meta: {
      title: '系统处理中'
    }
  },
  {
    path: '/processing',
    name: 'ProcessingPage',
    component: () => import('../views/ProcessingPage.vue'),
    meta: {
      title: '系统处理中'
    }
  },
  {
    path: '/report-expired',
    name: 'ReportExpired',
    component: () => import('@/views/ReportExpired.vue'),
    meta: {
      title: '报告过期'
    }
  },
  {
    path: '/risk-report',
    name: 'Report',
    component: () => import('../views/Report.vue'),
    meta: {
      title: '报告评估'
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: () => import('../views/Report.vue'),
    meta: {
      title: '报告评估'
    }
  },
  {
    path: '/demo',
    name: 'Demo',
    component: () => import('../views/Demo.vue'),
    meta: {
      title: '报告示例'
    }
  },
  {
    path: '/service-agreement',
    name: 'ServiceAgreement',
    component: ServiceAgreement,
    meta: {
      title: '服务协议'
    }
  },
  {
    path: '/wechat',
    name: 'Wechat',
    component: () => import('../views/Wechat.vue'),
    meta: {
      title: '打开微信小程序'
    }
  },
  {
    path: '*',
    name: 'UserFormInput',
    component: () => import('../views/UserFormInput.vue'),
    meta: {
      title: 'AI风控检测'
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  
  next();
});

export default router;
